import { createDuoToneIcon } from './helpers/createDuoToneIcon'

export const WarningDuoTone = createDuoToneIcon(
  'WarningDuoTone',
  [
    [
      'path',
      {
        d: 'M12 2C13.2556 2 14.1959 2.7424 15.042 3.78418C15.8818 4.81831 16.7837 6.34361 17.9189 8.25977L19.8662 11.5459C21.0486 13.5417 21.989 15.1257 22.5107 16.4023C23.0349 17.685 23.2402 18.9033 22.6055 20.0254C21.9698 21.1485 20.8207 21.595 19.4541 21.7988C18.0946 22.0015 16.2587 22 13.9473 22H10.0527C7.74165 22 5.90625 22.0014 4.54688 21.7988C3.18008 21.5951 2.03026 21.1487 1.39453 20.0254C0.75981 18.9033 0.965068 17.6851 1.48926 16.4023C2.01105 15.1256 2.95231 13.5418 4.13477 11.5459L6.08105 8.25977C7.21628 6.3436 8.11822 4.81831 8.95801 3.78418C9.80405 2.74238 10.7444 2.00004 12 2Z',
        stroke: 'none',
        key: 'WarningDuoTone-0',
      },
    ],
    [
      'path',
      {
        d: 'M11.9998 14.3633C11.5165 14.3633 11.1248 13.9715 11.1248 13.4883L11.1248 8.98828C11.1248 8.50503 11.5165 8.11328 11.9998 8.11328C12.483 8.11328 12.8748 8.50503 12.8748 8.98828L12.8748 13.4883C12.8748 13.9715 12.483 14.3633 11.9998 14.3633ZM11.9998 17.875C11.5165 17.875 11.1248 17.4832 11.1248 17V16.9902C11.1248 16.507 11.5165 16.1152 11.9998 16.1152C12.483 16.1152 12.8748 16.507 12.8748 16.9902V17C12.8748 17.4832 12.483 17.875 11.9998 17.875Z',
        stroke: 'none',
        key: 'WarningDuoTone-1',
      },
    ],
  ],
  {
    defaultGradient: 'yellow',
    defaultForegroundClassName: 'fill-foreground',
  },
)

WarningDuoTone.displayName = 'WarningDuoTone'
